import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import ".././App.scss";
import Layout from "./Layout";
import PWAInitailizer from "../utils/PWA";
import ReduxProvider from "../providers/reduxProvider";
import ReactQueryProvider from "../providers/reactQueryProvider";

const App = () => {
  useEffect(() => {
    const handleLanguageChange = (e) => {
      const lang = e.detail.language;

      // Facebook Pixel
      if (lang === "id") {
        if (!window.fbq) {
          (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
          );
        }

        window.fbq("init", "1128016987686618");
        window.fbq("track", "PageView");
      }

      // Google Tag Manager
      const gtmIdMap = {
        au: process.env.REACT_APP_GA_TRACKING_ID_FOR_AU,
        vn: process.env.REACT_APP_GA_TRACKING_ID_FOR_VN,
        id: process.env.REACT_APP_GA_TRACKING_ID_FOR_ID,
      };

      const trackingId = gtmIdMap[lang];
      const existingScripts = document.querySelectorAll(
        'script[src*="googletagmanager.com/gtag/js?id="]'
      );
      if (!trackingId && existingScripts.length > 0) {
        existingScripts.forEach((script) => script.remove());
      }
      if (trackingId) {
        const existingScripts = document.querySelectorAll(
          'script[src*="googletagmanager.com/gtag/js?id="]'
        );
        existingScripts.forEach((script) => {
          const src = script.getAttribute("src");
          if (!src.includes(trackingId)) {
            script.remove();
          }
        });

        if (!document.querySelector(`script[src*="${trackingId}"]`)) {
          const script = document.createElement("script");
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
          document.head.appendChild(script);
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "gtm.js",
          "gtm.start": new Date().getTime(),
        });

        window.gtag = function () {
          window.dataLayer.push(arguments);
        };

        window.gtag("js", new Date());
        window.gtag("config", trackingId, {
          page_path: "/ABBOTT" + window.location.pathname,
        });
      }
    };

    window.addEventListener("languageChanged", handleLanguageChange);

    return () => {
      window.removeEventListener("languageChanged", handleLanguageChange);
    };
  }, []);
  return (
    <ReduxProvider>
      <ReactQueryProvider>
        <CssBaseline />
        <BrowserRouter>
          <PWAInitailizer />
          <Layout />
        </BrowserRouter>
      </ReactQueryProvider>
    </ReduxProvider>
  );
};

export default App;
